import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MenuExploracion from "./MenuAbordajes";
import MenuSondas from "./MenuSondas";
import Simulador from "./Simulador";

function mapStateToProps(state){
	return {
		exploracion:state.exploracion,
		usr:state.login.user,
	};
}

class ExploracionConnected extends Component{
	static propTypes = {
		exploracion:PropTypes.object,
		usr:PropTypes.object,
	}
	render(){
		if(this.props.exploracion.abordajeActual === -1){
			return <MenuExploracion/>;
		}else if(!this.props.usr.acf.sondasVistas){
			return <MenuSondas/>;
		}else{
			return <Simulador key={this.props.exploracion.casoActual+"_"+this.props.exploracion.abordajeActual}/>;
		}
	}
}

export default connect(mapStateToProps)(ExploracionConnected);